module.exports = "<th>Тип договора</th>\n<td>\n  <terms ng-if=\"::dealTypeIs('rent')\" items=\"::terms.contract_rent\" source=\"source.contract\"/>\n  <terms ng-if=\"::dealTypeIs('sale')\" items=\"::terms.contract_sale\" source=\"source.contract\"/>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/commercial/contract.html
// module id = 324
// module chunks = 0